export default {
    dashboard: {
        title: 'Dashboard',
        totalLogs: 'Log Totali',
        errors: 'Errori (24h)',
        activeAlerts: 'Alert Attivi',
        activeWebhooks: 'Webhook Attivi',
        distribution: 'Distribuzione Log per Tipo',
        trend: 'Trend Log (24h)',
        recentAlerts: 'Alert Recenti'
    },
    search: {
        title: 'Ricerca Log',
        filters: {
            collection: 'Collezione',
            period: 'Periodo',
            types: 'Tipi',
            search: 'Cerca nei log...'
        },
        table: {
            date: 'Data',
            type: 'Tipo',
            message: 'Messaggio'
        }
    },
    alerts: {
        title: 'Configurazione Alert',
        baseThresholds: 'Soglie di Base',
        errorRate: 'Tasso di Errori',
        warningCount: 'Limite Warning',
        customMetrics: 'Metriche Personalizzate'
    },
    webhooks: {
        title: 'Gestione Webhook',
        form: {
            name: 'Nome',
            url: 'URL',
            events: 'Eventi',
            severity: 'Severità',
            headers: 'Headers Personalizzati'
        },
        status: {
            active: 'Attivo',
            inactive: 'Inattivo'
        }
    },
    common: {
        severity: {
            low: 'Bassa',
            medium: 'Media',
            high: 'Alta'
        },
        actions: {
            search: 'Cerca',
            save: 'Salva',
            cancel: 'Annulla',
            delete: 'Elimina',
            test: 'Test',
            export: 'Esporta'
        }
    }
}; 